import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import Upload from "./Upload";
import axios from "axios";
import Loader from "./Loader";
import Thumbs from "./Thumbs";
import resizebase64 from "resize-base64";

export default function UploadForm() {
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorArray, setErrorArray] = useState([]);

  const [status, setStatus] = useState("open");

  const initialValues = {
    kennzeichen1: "",
    kennzeichen2: "",
    kennzeichen3: "",
    name: "",
    email: "",
    firma: "",
    imageFront: [],
    imageBack: [],
  };

  function submit(values) {
    setErrorArray([]);
    const eArr = [];
    let attachment1 = values.imageFront;

    let attachment2 = values.imageBack;

    const data = {
      kennzeichen:
        values.kennzeichen1?.toUpperCase() +
        "-" +
        values.kennzeichen2?.toUpperCase() +
        " " +
        values.kennzeichen3?.toUpperCase(),
      name: values.name,
      email: values.email,
      firma: values.firma,
      imageFront: attachment1,
      imageBack: attachment2,
    };
    if (!values.kennzeichen1?.length) eArr.push("kennzeichen1");
    if (!values.kennzeichen2?.length) eArr.push("kennzeichen2");
    if (!values.kennzeichen3?.length) eArr.push("kennzeichen3");

    if (!data.name?.length) eArr.push("name");
    if (!data.email?.length) eArr.push("email");
    if (!data.imageFront?.length) eArr.push("imageFront");
    if (!data.imageBack?.length) eArr.push("imageBack");

    if (eArr.length) {
      setErrorArray(eArr);
      setErrorMessage("Bitte fülle alle Felder aus.");
      return;
    }

    setStatus("sending");

    axios
      .post("https://www.emover24.com/wp-json/emoverupload/v1/upload", data)
      .then((response) => {
        console.log(response);
        setStatus("send");
      })
      .catch((error) => {
        setStatus("open");
        setErrorMessage("Bei der Übermittlung ist ein Fehler aufgetreten.");
      });
  }

  function checkError(name) {
    if (errorArray.find((item) => item === name)) return "error-item";
    return "";
  }

  return (
    <div className="form">
      <Formik
        onSubmit={(values) => submit(values)}
        initialValues={initialValues}
      >
        <Form>
          {status === "sending" && <Loader />}
          {status === "open" && (
            <>
              <div
                style={{ display: status === "sending" ? "none" : "block" }}
                className="field-group"
              >
                <label htmlFor="kennzeichen">Kennzeichen*</label>
                <div className="kz-grid">
                  <Field
                    class={checkError("kennzeichen1")}
                    type="text"
                    name="kennzeichen1"
                    id="kennzeichen"
                  />
                  <Field
                    class={checkError("kennzeichen2")}
                    type="text"
                    name="kennzeichen2"
                    id="kennzeichen"
                  />
                  <Field
                    class={checkError("kennzeichen3")}
                    type="text"
                    name="kennzeichen3"
                    id="kennzeichen"
                  />
                </div>
              </div>
              <div className="field-group">
                <label htmlFor="name">Vor- und Nachname*</label>
                <Field
                  class={checkError("name")}
                  type="text"
                  name="name"
                  id="name"
                />
              </div>
              <div className="field-group">
                <label htmlFor="firma">Firma</label>
                <Field
                  class={checkError("firma")}
                  type="text"
                  name="firma"
                  id="firma"
                />
              </div>
              <div className="field-group">
                <label htmlFor="email">E-Mail (für die Bestätigung)</label>
                <Field
                  class={checkError("email")}
                  type="email"
                  name="email"
                  id="email"
                />
              </div>
              <div className="field-grid">
                <div className={`field-group ${checkError("imageFront")}`}>
                  <label htmlFor="image-front">Vorderseite</label>
                  <Upload name="imageFront" />
                </div>
                <div className={`field-group ${checkError("imageBack")}`}>
                  <label htmlFor="image-back">Rückseite</label>
                  <Upload name="imageBack" />
                </div>
              </div>
              {errorMessage && <div className="error">{errorMessage}</div>}
              <div className="infotext">
                Mit dem Upload stimmst du unseren Datenschutzbedingungen zu.
              </div>
              <button className="submit" type="submit">
                Absenden
              </button>
            </>
          )}
          {status === "send" && (
            <div>
              <Thumbs />
              <h3>Versand erfolgreich</h3>
              <p>
                Vielen Dank. Die Übermittlung deines Fahrzeugscheins hat perfekt
                funktioniert. Eine Bestätigung ist direkt an deine
                E-Mail-Adresse rausgegangen.
              </p>
              <a href="/thg-quote">
                <img
                  src={
                    "https://www.emover24.com/wp-content/uploads/2022/10/thg.png"
                  }
                  alt="THG"
                  style={{ maxWidth: "100%" }}
                />
              </a>
            </div>
          )}
        </Form>
      </Formik>
    </div>
  );
}
